import { render, staticRenderFns } from "./V_Creator_Events_List.vue?vue&type=template&id=1154975b&scoped=true&"
import script from "./V_Creator_Events_List.vue?vue&type=script&lang=js&"
export * from "./V_Creator_Events_List.vue?vue&type=script&lang=js&"
import style0 from "./V_Creator_Events_List.vue?vue&type=style&index=0&id=1154975b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154975b",
  null
  
)

export default component.exports